<template>
	<div id="train">
    <p class="nav" @click="toCourseList"><span class="el-icon-arrow-left"></span><span>返回</span></p>
    <div class="btn-box">
      <span v-if="lastRecordId" @click="lastStudy">上一课录音</span>
      <!--<span v-if="nextRecordId" @click="nextStudy">下一课录音</span>-->
    </div>
    <div class="video-box">
      <video ref="video" :src="record.url" controls="controls" class="video">
        您的浏览器不支持 video 标签。
      </video>
    </div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.query.id, //技能提升-场景id
      type: this.$route.query.type, //上级tab类型
      tabMajorId: this.$route.query.tabMajorId, //上级tab的id
      majorId: this.$route.query.majorId, //businessMajorId
      lastRecordId: null, //上一课程id
      nextRecordId: null, //下一课程id
      record: {},
      recordId: this.$route.query.recordId, //录音id
    }
  },
  components: {
    
  },
  created() {
    
  },
  mounted() {
		this.getRecordDetail();
  },
  methods: {
    getRecordDetail() {
      this.$http.post(API_ROOT.college + '/goodRecord/queryRecomendRecord', {'businessMajorId': this.majorId}).then(res=> {
        var result = res.data;
        if(result.success) {
          this.lastRecordId = result.data.lastRecordId;
          this.nextRecordId = result.data.nextRecordId;
          this.record = result.data.record;
          this.recordId = result.data.record.recordId;
          this.$nextTick(function() {
            this.$refs.video.addEventListener('ended', () => { //该视频播放是否已结束
              this.submitKnowledge();
            }, false);
          });
        }else {
          this.$alert(result.msg);
        }
      },res=> {
        this.$alert("AJAX请求接口异常（/course/getKnowledgeListXlk）！");
      })
    },
    //录音完成后提交
    submitKnowledge() {
      let data = {
        'recordId': this.recordId,
        'businessMajorId': this.$route.query.id
      }
      this.$http.post(API_ROOT.college + '/goodRecord/listenGoodRecord', data).then(res=> {
        var result = res.data;
        if(result.success) {
          
        }else {
          this.$alert(result.msg);
        }
      },res=> {
        this.$alert("AJAX请求接口异常（/goodRecord/listenGoodRecord）！");
      })
    },
    lastStudy() {
      window.location.href = '/tjkStudy/vedioDetail?recordId='+this.lastRecordId+'&type='+this.type+'&tabMajorId='+this.tabMajorId;
    },
    nextStudy() {
      if(this.unlock) {
        window.location.href = '/tjkStudy/vedioDetail?recordId='+this.nextRecordId+'&type='+this.type+'&tabMajorId='+this.tabMajorId;
      }
    },
    //返回课程
    toCourseList() {
      this.$router.go(-1)
    },
  } 
}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// ./src/page/train/recordDetail.vue